<nb-card style="height: 80vh; padding: 5px">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="pie-chart-outline"></nb-icon>
        <div class="ml-2" i18n>Select a time period and the campaign to view deliveries breakdown</div>
      </div>
      <button
        nbButton
        outline
        [disabled]="refreshButton"
        status="info"
        shape="round"
        size="small"
        (click)="refresh()"
        nbTooltip="Refresh deliveries"
        i18n-nbTooltip
      >
        <nb-icon icon="refresh-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="row">
      <div class="col"><label i18n>Start:</label></div>
      <div class="col-9">
        <nb-form-field>
          <nb-icon nbPrefix icon="calendar-outline" pack="eva"></nb-icon>
          <input
            nbInput
            [nbDatepicker]="datepicker"
            style="width: 100%"
            icon="at-outline"
            [(ngModel)]="start"
            [ngModelOptions]="{ standalone: true }"
          />
          <nb-datepicker #datepicker id="start" (dateChange)="startDate($event)" [max]="max"></nb-datepicker>
        </nb-form-field>
      </div>
    </div>
    <br />

    <div class="row">
      <div class="col"><label i18n>End:</label></div>
      <div class="col-9">
        <nb-form-field>
          <nb-icon nbPrefix icon="calendar-outline" pack="eva"></nb-icon>
          <input
            nbInput
            [nbDatepicker]="datepickerEnd"
            style="width: 100%"
            [(ngModel)]="end"
            [ngModelOptions]="{ standalone: true }"
          />
          <nb-datepicker #datepickerEnd id="finish" (dateChange)="endDate($event)" [max]="max"></nb-datepicker>
        </nb-form-field>
      </div>
    </div>
    <br />

    <div class="row">
      <div class="col">
        <label i18n>Select Campaign:</label>
      </div>
      <div class="col-9">
        <div style="width: 320px">
          <ng-select
            [(ngModel)]="selectedCampaignID"
            (change)="selected()"
            [multiple]="false"
            placeholder="Select Campaign"
          >
            <ng-option *ngFor="let campaign of campaign$ | async" [value]="campaign.id">
              {{ campaign.name }}
            </ng-option>
          </ng-select>
        </div>
      </div>
    </div>
    <br />
    <hr />

    <div *ngIf="isSelected" class="row">
      <div class="wrapper">
        <div class="overlay" *ngIf="showSpinner">
          <div class="spinner-wrapper">
            <app-spinner></app-spinner>
          </div>
        </div>

        <div class="loaded-content" [class.blurred]="showSpinner">
          <div class="col-lg-12">
            <nb-card>
              <nb-card-header>
                <div style="font-weight: bold" i18n>Total deliveries: {{ count }}</div>
              </nb-card-header>
              <nb-card-body>
                <canvas baseChart type="bar" [data]="data" [options]="options"></canvas>
              </nb-card-body>
            </nb-card>
          </div>
        </div>
      </div>
    </div>
  </nb-card-body>
</nb-card>
